export { default } from './TabFactsheet';